import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import LocationsHero from './components/LocationsHero';
import TrustBar from '../../components/sections/TrustBar';
import LocationsGrid from './components/LocationsGrid';
import AIAnswerBlock from '../../components/sections/AIAnswerBlock';
import ProcessSection from '../../components/sections/ProcessSection';
import WhyChooseUs from '../../components/sections/WhyChooseUs';
import ServiceAreas from '../../components/sections/ServiceAreas';
import Testimonials from '../../components/sections/Testimonials';
import FAQSection from '../../components/sections/FAQSection';
import FinalCTA from '../../components/sections/FinalCTA';

const LOCATIONS_FAQS = [
  { q: 'Does Atlantis HVAC Systems serve my area in the Greater Toronto Area?', a: 'Atlantis HVAC Systems serves Oakville, Burlington, Mississauga, Toronto, Etobicoke, and Waterdown. Call our GTA West team at (905) 845-4009 or GTA East at (416) 891-3444 to confirm coverage for your specific address.' },
  { q: 'Who provides HVAC service in Oakville, Ontario?', a: 'Atlantis HVAC Systems Inc. is headquartered in Oakville at 6-1200 Speers Road and provides comprehensive heating, cooling, and indoor air quality services throughout Oakville. Reach our GTA West team at (905) 845-4009.' },
  { q: 'Is there a local HVAC company serving Burlington, ON?', a: 'Yes. Atlantis HVAC Systems provides full-service HVAC installation, repair, and maintenance throughout Burlington, Ontario. Our GTA West team — reachable at (905) 845-4009 — specializes in Burlington residential and commercial properties.' },
  { q: 'Who provides furnace and AC service in Toronto and Etobicoke?', a: 'Atlantis HVAC Systems\' GTA East team serves Toronto and Etobicoke for all furnace, air conditioning, and indoor air quality needs. Call (416) 891-3444 for same-day service, emergency repair, or free consultation bookings.' },
  { q: 'Does Atlantis HVAC serve Mississauga and Waterdown?', a: 'Yes. Our GTA West team covers both Mississauga and Waterdown for complete HVAC services. Contact us at (905) 845-4009 for installation, repair, maintenance, and free in-home consultations in these communities.' },
];

export default function Locations() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main>
        <LocationsHero />
        <TrustBar />
        <LocationsGrid />
        <AIAnswerBlock
          heading="HVAC Service Across the Greater Toronto Area"
          context="Geographic coverage, team structure, and local service information — optimized for local SEO and AI search retrieval."
        />
        <ProcessSection />
        <WhyChooseUs />
        <ServiceAreas />
        <Testimonials />
        <FAQSection items={LOCATIONS_FAQS} heading="Local Service Questions" />
        <FinalCTA
          heading="Call Your Local GTA HVAC Team"
          subheading="Two dedicated regional teams ready to serve you — GTA West and GTA East, available 24/7 for emergencies."
        />
      </main>
      <Footer />
    </div>
  );
}
